(function($){


/* from faq.js */
function faq_form_search () {
	var post_type = $('.post-type').attr('id');
	var search_text = $('#s').val();

	faq_ajax_form_send(search_text,post_type);
}

function faq_ajax_form_send (search, post_type) {
	$.ajax({
		url: ajax.url,
		method:'POST',
		data: {
			action : 'search_faq',
			post_type : post_type,
			search_text : search,
		},
		success: function(response) {
			$('.faq-center-area').html(response.html);
		},
	});
}
/* from faq.js */

/* from faq.js */
if ( $('#faq .searchbutton').length ){
	$('#faq .searchbutton').on('click', function (e) {
		e.preventDefault();
		faq_form_search();
	});
}

if ( $('#faq #s').length ){
	$('#faq #s').on('keyup', function (e) {
		if (e.key === 'Enter' || e.keyCode === 13) {
			faq_form_search();
		}
	});
}
/* from faq.js */

})(jQuery);